import React from 'react'

import MobiinnIamge from '../../assets/imgs/mobiinn.jpg'
import MobiinnDismention from '../../assets/imgs/mobiinn.jpg?size'

import LocaleText from '../common/LocaleText'
import ResponsiveImg from '../common/ResponsiveImg'
import styles from './Mobiinn.scss'

export const Mobiinn = () => <div className={styles.mb28}>
  <div className={styles.text}>
    <LocaleText
      ja="働き方、遊び方、生き方でクルマはもっと自由になる。"
      en="Cars will become more free depending on how you work, play, and live."
    /><br/>
    <LocaleText
      ja="場所にとらわれない生活を、もっと自由に、もっと気軽に、もっと安心に。"
      en="A life that is not bound by location, more freely, more casually, and more securely."
    /><br/>
    <div className='mt-4' />
    <LocaleText
      ja="「暮らすように旅する」をサポートする、"
      en="Supporting 'traveling like living'"/><br/>
    <LocaleText
      ja="トヨタモビリティ東京によるパンライフカーのレンタルサービス。"
      en="Bread life car rental service by Toyota Mobility Tokyo."
    /><br/>
    <LocaleText
      ja="今後はさらにギアのレンタル、スポットの紹介などサービス拡大予定！"
      en="In the future, we plan to expand services such as gear rentals and spot introductions!"
    /><br/>
  </div>
  <div className={styles.imageMobiinn}>
    <ResponsiveImg
      url={MobiinnIamge}
      caption='MOBIINN'
      dimension={MobiinnDismention}
    />
  </div>
</div>

Mobiinn.displayName = 'Mobiinn'
export default Mobiinn
